/* eslint-disable prefer-reflect */
import { addEvent, removeEvent, Throttle } from '../utils/events';
import { isOverflowed } from '../utils/html';
require('jspolyfill-array.prototype.findIndex');

export class Pagination {

  /**
   * @param  {Dom}    pagination        pagination container
   */
  constructor(pagination) {
    this.pagination = pagination;
    this.magicNumberForResizeThrottling = 100;
    if (!this.isEverythingOk()) {
      return;
    }

    // Initialize pagination
    this.init();
  }

  init() {
    // Cast to real array and not nodeList
    this.pages = this.pagination.querySelectorAll(
      'li:not(.pagination__first):not(.pagination__prev):not(.pagination__next):not(.pagination__last)'
    );
    this.totalPages = this.pages.length;

    // Fetch the selected Page
    this.selectedPageIndex = Array.prototype.slice.call(this.pages).findIndex(
      (x) => x.classList.contains('pagination__current'));

    // Starting point for hidden pages - none
    this.maxAway = 0;

    // Add 'away-1' etc to the pages in the pagination
    this.assignAwayClasses();

    // Start the hiding at the maximum shown
    this.currentHiddenAways = this.maxAway + 1;

    // Bind the context with the event
    this.updatePagination = this.updatePagination.bind(this);

    this.windowResize = new Throttle(this.updatePagination, this.magicNumberForResizeThrottling);

    this.addListeners();
    this.updatePagination();
  }

  assignAwayClasses() {
    for (let i = 0; i < this.totalPages; i++) {
      if (i !== this.selectedPageIndex) {
        this.pages[i].classList.add(`away-${ Math.abs(this.selectedPageIndex - i) }`);
        if (Math.abs(this.selectedPageIndex - i) > this.maxAway) {
          this.maxAway = Math.abs(this.selectedPageIndex - i);
        }
      }
    }
  }

  removeAwayClasses() {
    for (const page of this.pages) {
      if (!page.classList.contains('pagination__current')) {
        page.className = '';
      }
    }
  }

  updatePagination() {
    if (isOverflowed(this.pagination, this.pagination.parentElement)) {
      this.hidePages();
    } else {
      this.showPages();
    }
  }

  hidePages() {
    if (this.currentHiddenAways !== 0) {
      this.currentHiddenAways--;
      for (const page of this.pages) {
        if (page.classList.contains(`away-${ this.currentHiddenAways }`)) {
          page.classList.add('hide');
        }
      }
      if (isOverflowed(this.pagination)) {
        this.hidePages();
      }
    }
  }

  showPages() {
    if (this.currentHiddenAways !== this.maxAway + 1) {
      for (const page of this.pages) {
        if (page.classList.contains(`away-${ this.currentHiddenAways }`)) {
          page.classList.remove('hide');
        }
      }
      this.currentHiddenAways++;
      this.updatePagination();
    }
  }

  addListeners() {
    addEvent(window, 'resize', this.windowResize.trigger);
  }

  destroy() {
    removeEvent(window, 'resize', this.windowResize.trigger);
    this.removeAwayClasses();
  }

  /* eslint-disable no-console */
  isEverythingOk() {
    if (!this.pagination) {
      console.warn('CommonUI - Alert - There\'s no pagination found');
      return false;
    }
    return true;
  }
  /* eslint-enable no-console */
}

/**
 * Creates a new alert instance
 * @param  {Object} config
 */
export default function initPagination(config = {}) {
  const { selector = '.js-pagination' } = config;
  let paginations = null;
  if (typeof selector === 'string') {
    for (const pagination of document.querySelectorAll(selector)) {
      paginations = new Pagination(pagination);
    }
  }
  return paginations;
}



// WEBPACK FOOTER //
// ./js/components/Pagination.js